/**
 * @author Artem Lytvynov
 * @copyright Artem Lytvynov
 * @license Apache-2.0
 */

export enum CONN_ATTRS_LIST {
  NAME = "name",
  TYPE = "type",
  DESCRIPTION = "description",
  SSL = "ssl",
  HOST = "host",
  PORT = "port",
  USER = "user",
  PASSWORD = "password",
  PROJECT_ID = "project-id",
  CREDENTIALS_KEY = "credentials-key",
  SHEET_ID = "sheet-id",
  REGION = "region",
  ACCESS_KEY = "access-key",
  SECRET_KEY = "secret-key",
  SCHEMA = "schema",
  ACCOUNT = "account",
  DATABASE = "database",
  ROLE = "role",
  WAREHOUSE = "warehouse",
}
